import app from './app';
import view from './view';

const router = async (route) => {
  const content = document.getElementById('app-content');
  content.innerHTML = '';

  switch (route) {
    case '': {
      content.appendChild(view.landing());
      break;
    }

    case '#/sign-in': {
      content.appendChild(view.signIn());
      break;
    }

    case '#/sign-up': {
      content.appendChild(view.signUp());
      break;
    }

    default: {
      content.appendChild(view.notFound());
    }
  }

  app.lib.i18n.render();
};

export default router;
